import React from 'react'

const Modals = () => {
    return (
       <>

  <div id="listing-cancellation-modal" className="modal modal-md">
    <div className="modal-background modal-dismiss" />
    <div className="modal-content">
      {/*Modal card*/}
      <div className="card">
        <header className="card-header">
          <div className="card-header-title">
            <span>Cancellation Terms</span>
          </div>
          <button className="modal-dismiss">
            <span className="icon">
              <i data-feather="x" />
            </span>
          </button>
        </header>
        <div className="card-content">
          <div className="modal-icon-list pb-5">
            <div className="icon-list-item">
              <i data-feather="calendar" />
              <p className="text">Cancellation is free up to 5 days before</p>
            </div>
            <div className="icon-list-item">
              <i data-feather="credit-card" />
              <p className="text">After 5 days, cancellation costs a 5% Fee</p>
            </div>
            <div className="icon-list-item">
              <i data-feather="alert-octagon" />
              <p className="text">You can't cancel an ongoing event</p>
            </div>
          </div>
          <div className="modal-text-block">
            <h4 className="title is-6 is-narrow">Additional terms</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Uterque
              enim summo bono fruitur, id est voluptate. Quodsi vultum tibi, si
              incessum fingeres.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*Share modal*/}
  <div id="listing-share-modal" className="modal modal-sm">
    <div className="modal-background modal-dismiss" />
    <div className="modal-content">
      {/*Modal card*/}
      <div className="card">
        <header className="card-header">
          <div className="card-header-title">
            <span>Share this event</span>
          </div>
          <button className="modal-dismiss">
            <span className="icon">
              <i data-feather="x" />
            </span>
          </button>
        </header>
        <div className="card-content">
          <div className="modal-icon-list">
            <a className="icon-list-item is-share-action">
              <i className="lab la-facebook-f" />
              <p className="text">Share on Facebook</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="lab la-twitter" />
              <p className="text">Share on Twitter</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="lab la-linkedin-in" />
              <p className="text">Share on Linkedin</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="las la-copy" />
              <p className="text">Copy URL</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="lab la-whatsapp" />
              <p className="text">Share on Whatsapp</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="lab la-facebook-messenger" />
              <p className="text">Share on Messenger</p>
            </a>
            <a className="icon-list-item is-share-action">
              <i className="las la-envelope-open" />
              <p className="text">Share by Email</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/*Whishlist modal*/}


<div id="listing-rules-modal" className="modal modal-md">
  <div className="modal-background modal-dismiss" />
  <div className="modal-content">
    {/*Modal card*/}
    <div className="card">
      <header className="card-header">
        <div className="card-header-title">
          <span>Event Rules</span>
        </div>
        <button className="modal-dismiss">
          <span className="icon">
            <i data-feather="x" />
          </span>
        </button>
      </header>
      <div className="card-content">
        <div className="modal-icon-list pb-5">
          <div className="icon-list-item">
            <i data-feather="clock" />
            <p className="text">Don't be late. We'll be starting without you if you are</p>
          </div>
          <div className="icon-list-item">
            <i data-feather="coffee" />
            <p className="text">Be nice and polite to other participants</p>
          </div>
          <div className="icon-list-item">
            <i data-feather="smile" />
            <p className="text">Wear a mask if physically attending (COVID-19)</p>
          </div>
        </div>
        <div className="modal-text-block">
          <h4 className="title is-6 is-narrow">Additional rules</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Uterque
            enim summo bono fruitur, id est voluptate. Quodsi vultum tibi, si
            incessum fingeres.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

       </>
    )
}

export default Modals;